// Character Show audio helpers — a play control appears ONLY when the shared
// backend supplies a verified, playable audio asset. All other states collapse
// to ONE concise, customer-facing message (no internal/technical detail, no
// browser speech, no seed/fake audio).

export function audioPlayable(audio) {
  return !!audio && audio.state === "ready" && Array.isArray(audio.lines) && audio.lines.length > 0;
}

export function audioStateMessage(state) {
  switch (state) {
    case "processing":
    case "generating":
    case "pending":
    case "queued":
      return "The pregame debate audio is being prepared — check back soon.";
    case "failed":
    case "error":
      return "Audio for this segment isn't available right now.";
    default:
      return "Audio isn't available for this segment yet.";
  }
}
